export const TRADE_DEFAULT_MARKET = process.env.REACT_APP_TRADE_DEFAULT_MARKET!

export const PERP_DEFAULT_MARKET = process.env.REACT_APP_PERP_DEFAULT_MARKET!

// The minimum order value for spot trading and perp trading, in USDT
export const MINIMUM_ORDER_VALUE = Number(
  process.env.REACT_APP_MINIMUM_ORDER_VALUE!,
)

export const MAXIMUM_LEVERAGE = 100
export const DEFAULT_LEVERAGE = 5

export const MAX_TRADE_FEE_RATE = 255 // 255 = 2.55%
export const TRADE_FEE_RATE_SCALE = 10000 // 10000 = 100%
export const BASE_FEE_USD_VALUE = '0.2' // 0.2 USD

// If the base scale greater than 6, the amount value will be compressed.
// Like 233.43k or 233.43m
export const COMPRESSED_VALUE_SCALE = 6

export const ORDER_FAIL_REASONS = {
  ORDER_NOT_FOUND: 'Order error: the specific order not found.',
  ORDER_INVALID: 'Order error: the specific order is invalid.',
  ORDER_EXCEEDED: 'Order error: order exceeds the maximum active limit.',
  PRICE_EXCEEDED: 'Order error: limit price exceeded than maximum allowed.',
  PRICE_LESS_THAN: 'Order error: limit price less than minimum allowed.',
  ACCOUNT_NO_ENOUGH_AVAILABLE: 'Order error: no enough available balance.',
  MARKET_NOT_READY: 'Market error: Fair prices are not fetched.',
  // This error key is customed by us, not from backend
  // Why? Because the user want to close the position, must be canceling the same direction open order first.
  // But the backend will return the same error message with ACCOUNT_NO_ENOUGH_AVAILABLE,
  // so we customed the error key to distinguish the two errors.
  ACCOUNT_NO_ENOUGH_AVAILABLE_FROZEN:
    'Close failed: you have open orders, please cancel them first.',
} as const
